export class RequestCreate { 

    public requestId : number|undefined = undefined;

}